<template>
    <modal :open="open" title="Edit Article Feed" @close="close()">

        <form v-on:submit.prevent="saveFeed()" v-if="rssFeed">

            <field :errors="errors" name="name" :label="$t('Feed URL')" :help="$t('The url of the Article feed you want to import')">
                <input type="text" id="add-page-title" v-model="rssFeed.url" placeholder="https://">
            </field>

            <field :errors="errors" name="name" :label="$t('When imported add the articles to these blocks...')" >

                <input v-model="block_search" type="text" v-on:focus="focusSearch()" v-on:blur="blurSearch()" v-on:keyup="focusSearch()" placeholder="Search blocks to add articles to...">
                <div class="live-search" v-if="results&&results.length">
                    <div class="live-search__contents">
                        <span v-bind:key="result.id" v-for="result in results">
                            <div v-if="result.article_type!='auto'" class="result" v-on:mousedown="clickResult($event, result)">
                                {{result.name}}

                                <i class="material-icons">add</i>
                            </div>
                        </span>
                    </div>
                </div>
                <div class="page-inline" v-bind:key="block.id" v-for="block in rssFeed.blocks">
                    <p>{{block.name}}
                        <span v-if="block.article_type=='auto'" style="float: right">(auto)</span>
                        <a class="remove" v-if="block.article_type!='auto'" @click="removeBlock(block)"><i class="material-icons">close</i></a>
                    </p>
                </div>
            </field>

            <div class="modal__done">
                <button :disabled="saving" id="add-page-save"><span v-if="!saving" v-t="'Save Article Feed'"></span><span v-if="saving"><i class="material-icons">sync</i> Saving</span></button>
              <a class="button--close" @click="deleteFeed()" v-t="'Delete Feed'"></a>
            </div>
        </form>
    </modal>
</template>

<script>
    import Modal from '@/components/Modal.vue'
    import Field from '@/components/Field.vue'

    export default {
        props: ['open', 'rssFeed'],
        components: {
            Modal,
            Field
        },
        data () {
            return {
                saving: null,
                results: [],
                errors: {},
                blocks: [],
                block_search: '',
            }
        },
        methods: {
            close (data) {
                this.$emit('close', data)
                this.saving = false
                this.errors = {}
                this.rssFeed = {
                    path: '',
                    blocks: [],
                    destination: ''
                }
            },
            blurSearch () {
              this.results = []
            },
            clickResult ($event, block) {
                $event.preventDefault();
                this.rssFeed.blocks.push(block);
                this.block_search = ''
                this.results = [];
                this.focused = false;
                this.results = [];
            },
            removeBlock (block) {
                this.rssFeed.blocks.splice( this.rssFeed.blocks.indexOf(block), 1);
            },
            deleteFeed () {
                if(window.confirm('Are you sure you want to delete this article feed?')){
                    this.$http.delete('/rss-feeds/'+this.rssFeed.id+'/').then(data => {
                        this.saving = false
                        this.$store.dispatch('messages/success', 'RSS feed deleted')
                        this.close(null)
                    }).catch(errors => {
                        this.saving = null
                    })
                }
            },
            focusSearch () {
                var current_block_ids = [];
                for(var i=0; i<this.rssFeed.blocks.length; i++){
                    var block = this.rssFeed.blocks[i]
                    current_block_ids.push(block.id);
                }

                this.results = [];
                for(var j=0; j<this.blocks.length; j++){
                    var block2 = this.blocks[j]
                    if(current_block_ids.indexOf(block2.id) === -1){
                      if(this.block_search.length > 0){
                          if(block2.name.toLowerCase().indexOf(this.block_search.toLowerCase()) !== -1){
                            this.results.push(block2);
                          }
                      }else {
                        this.results.push(block2);
                      }
                    }
                }
            },
            saveFeed () {
                this.saving = true
                this.errors = {}
                this.$http.put('/rss-feeds/'+this.rssFeed.id+'/', this.rssFeed).then(data => {
                    this.saving = false
                    this.$store.dispatch('messages/success', 'RSS feed updated')
                    this.close(data.data)
                }).catch(errors => {
                    this.saving = null
                    this.errors = errors.response.data
                })
            },
            loadData() {
              this.$http.get('/blocks/').then(blocks => {
                  this.blocks = blocks.data
              })
            }
        },
        mounted () {
            this.loadData()
        }
    }
</script>

